module.exports = __webpack_public_path__ + "img/person.8dff8bdd.png";